module.exports = __webpack_public_path__ + "static/img/group-5.0ef3c35.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/group-5.svg
// module id = SMPz
// module chunks = 1